<template>
    <header>
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item c2b-user-menu-container">
                    <div class="dropdown" data-toggle="dropdown">
                        <p class="c2b-subscriber-name">{{userAuthenticated.name}}</p>
                        <p class="c2b-user-authenticated-name">{{userAuthenticated.email}}</p>
                    </div>

                    <div class="dropdown-menu">                        
                        <div class="dropdown-content">
                            <div class="dropdown-user-authenticated">
                                <p>{{userAuthenticated.name}}</p>
                                <p class="text-muted">{{userAuthenticated.email}}</p>
                            </div>
                        </div>

                        <div class="dropdown-actions">
                            <div class="text-right">
                                <button type="button" 
                                    class="btn btn-outline-secondary"
                                    @click="logout()">
                                    Sair
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </nav>
    </header> 
</template>

<script>
import {mapState} from 'vuex'
import {logout} from '@/auth/services/SessionService'
import storeConstants from '@/utils/constants/StoreConstants'

export default {
    name: 'TopMenuCmp',
    methods: {
        async logout() {
            await logout()
        },
    },
    computed: {
       ...mapState({
           userAuthenticated: state => state.userAuthenticated,
       }),
    },
}
</script>

<style lang="scss" scoped>
header {
    .navbar.navbar-light.bg-light {
        height: 56px;
        background-color: #fff !important;

        .c2b-user-menu-container {
            padding: 0 8px;
            position: relative;
            border: 1px solid #ccc;
            border-radius: 2px;
            transition: background-color .3s ease;                        
            will-change: background-color;

            &:active {
                background-color: whitesmoke;
            }

            p {
                margin-bottom: 0;
            }

            .dropdown {
                cursor: pointer;
            }

            .c2b-subscriber-name {
                margin-bottom: 0;
                font-size: 1em;
                color: #555;
                font-weight: 600;
                text-transform: uppercase;
                text-align: right;
            }

            .c2b-user-authenticated-name {
                color: #666;
                padding-bottom: 5px;
                font-size: .9em;
                text-align: right;
                font-weight: 400;
                line-height: .9;
            }

            .dropdown-menu {
                position: absolute;
                right: -1px;
                left: auto;
                width: 350px;
                padding: 0;
                font-size: 1em;
                border-radius: 2px;
                z-index: 100000;

                .dropdown-menu-arrow {
                    position: relative;
                    top: -18px;
                    left: 98%;
                    width: 0;
                    height: 0;
                }

                .dropdown-menu-arrow:before,
                .dropdown-menu-arrow:after {
                    content: "";
                    position: absolute;
                    display: block;
                    width: 0;
                    height: 0;
                    border-width: 7px 8px;
                    border-style: solid;
                    border-color: transparent;
                    z-index: 1001;
                }

                .dropdown-content {
                    padding: 0;
                    max-height: 500px;
                    overflow-y: auto;

                    .dropdown-user-authenticated {
                        cursor: pointer;
                        padding: 5px 15px;
                        border-bottom: 1px solid #f1f2f3;                            
                    }

                    p {
                        margin-bottom: 0;
                    }
                }

                .dropdown-actions {
                    padding: 10px;
                }
            }
        }
    }
}
</style>
